'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Placeholder = function Placeholder(_ref) {
  var image = _ref.image,
      size = _ref.size;

  var style = {
    maxHeight: size
  };

  return _react2.default.createElement(
    'div',
    { style: style },
    image
  );
};

Placeholder.propTypes = {
  image: _propTypes2.default.node.isRequired,
  size: _propTypes2.default.number.isRequired
  // status: PropTypes.string.isRequired,
};

exports.default = Placeholder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/Thumb/Placeholder.js
// module id = 1998
// module chunks = 1